var map = {
	"./403.json": 780,
	"./404.json": 781,
	"./accessSettings.json": 782,
	"./adverseEvents.json": 783,
	"./audit.json": 784,
	"./buttons.json": 785,
	"./calculations.json": 786,
	"./calendar.json": 323,
	"./clients.json": 787,
	"./clinicalTrailsSettings.json": 788,
	"./coa.json": 789,
	"./dashboard.json": 790,
	"./datatable.json": 791,
	"./eqTypes.json": 792,
	"./equipments.json": 793,
	"./experiments.json": 794,
	"./inventories.json": 795,
	"./laboratories.json": 796,
	"./locations.json": 797,
	"./lookup.json": 798,
	"./main.json": 799,
	"./maintTypes.json": 800,
	"./materialTypes.json": 801,
	"./materials.json": 802,
	"./methods.json": 803,
	"./monitoringVisits.json": 804,
	"./navbar.json": 805,
	"./orders.json": 806,
	"./organisations.json": 807,
	"./patients.json": 808,
	"./personel.json": 809,
	"./priceList.json": 810,
	"./projects.json": 811,
	"./reagents.json": 812,
	"./reports.json": 813,
	"./samples.json": 814,
	"./services.json": 815,
	"./signin.json": 816,
	"./signup.json": 817,
	"./specifications.json": 818,
	"./superscript.json": 819,
	"./suppliers.json": 820,
	"./systemEmail.json": 821,
	"./tasks.json": 822,
	"./testPlans.json": 823,
	"./tests.json": 824,
	"./timetable.json": 825,
	"./trainings.json": 826,
	"./transactions.json": 827,
	"./trialsManagement.json": 828,
	"./uom.json": 829,
	"./validation.json": 830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 779;